import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { TranslationsProvider } from '../wp_components/context/TranslationContext';

window.React = React;
window.ReactDOM = ReactDOM;
window.createRoot = createRoot;
window.TranslationsProvider = TranslationsProvider;

if (typeof global !== 'undefined') {
    global.React = React;
    global.ReactDOM = ReactDOM;
    global.createRoot = createRoot;
    global.TranslationsProvider = TranslationsProvider;
}